import { FooterService } from '../../../core/services/footer.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { filter } from 'rxjs';
import { MemoryService } from '../../../core/services/memory.service';
import { StorageService } from '../../../core/services/storage.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-navigation',
  imports: [RouterOutlet, RouterLink, MatSidenavModule, MatListModule, MatToolbarModule, MatIconModule, MatButtonModule, TranslocoPipe],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent implements OnInit {
  isMobile: boolean = false;
  sidenav: boolean = false;

  constructor(private router: Router, private breakpointObserver: BreakpointObserver, public footerService: FooterService, private memoryService: MemoryService, private activatedRoute: ActivatedRoute, private storageService: StorageService) {
  }

  ngOnInit(): void {
    this.memoryService.customerId = this.activatedRoute.snapshot.queryParams['customerId'];

    if (!this.memoryService.customerId) {
      this.router.navigate(['/login']);
    }

    this.breakpointObserver.observe(['(max-width: 800px)']).subscribe((result) => {
      this.isMobile = result.matches;
      this.sidenav = !this.isMobile;
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.footerService.hideFooter();
    });
  }

  toggelSidenav(): void {
    this.sidenav = !this.sidenav;
  }

  logout(): void {
    this.storageService.removeRefreshToken();
    this.storageService.removeEmail();
    this.router.navigate(['login']);
  }
}
